<template>
    <div class="row h-100 justify-content-center align-items-center bg-warning text-light">
        <div class="col-sm-8 col-11" v-if="project">
            <h1>Proyecto</h1>

            <div class="form-group mt-4">
                <label for="project_project">Nombre del proyecto</label>

                <input type="text" id="project_project" class="form-control" v-model="project.project" />
            </div>

            <div class="form-group mt-4">
                <label for="project_descripcion">Fecha que inició el proyecto</label>

                <input type="date" class="form-control" v-model="project.fecha_inicio" />
            </div>

            <div class="form-group mt-4">
                <label for="project_descripcion">Fecha que finalizó el proyecto (opcional)</label>

                <input type="date" class="form-control" v-model="project.fecha_final" />
            </div>

            <button class="btn w-100 btn-light btn-lg mt-4" :disabled="disabled" @click="set">Siguiente</button>
        </div>
    </div>
</template>

<script>
import router from "../router";
import { mapActions, mapGetters } from "vuex";
export default {
    data() {
        return {
            project: null,
            ...mapGetters(["getProject"]),
        };
    },
    mounted() {
        this.project = this.getProject();
    },
    computed: {
        disabled: function () {
            return this.project.project === null || this.project.fecha_final === null;
        },
    },
    methods: {
        set() {
            this.setProject(this.project);
            router.push("Project2");
        },
        ...mapActions(["setProject"]),
    },
};
</script>
